import { computed, reactive } from 'vue';

const layoutConfig = reactive({
    preset: 'Aura',
    primary: 'emerald',
    surface: null,
    darkTheme: JSON.parse(localStorage.getItem('darkMode')) || false,
    devMode: JSON.parse(localStorage.getItem('devMode')) || false,
    sidebarCollapsed: JSON.parse(localStorage.getItem('sidebarCollapsed')) || false,
    menuMode: 'static'
});

const layoutState = reactive({
    staticMenuInactive: false,
    overlayMenuActive: false,
    profileSidebarVisible: false,
    configSidebarVisible: false,
    sidebarExpanded: false,
    menuHoverActive: false,
    activeMenuItem: null,
    activePath: null
});

export function useLayout() {
    const toggleDarkMode = () => {
        if (!document.startViewTransition) {
            executeDarkModeToggle();

            return;
        }

        document.startViewTransition(() => executeDarkModeToggle(event));
    };

    const toggleDevMode = () => {
        layoutConfig.devMode = !layoutConfig.devMode;

        localStorage.setItem('devMode', layoutConfig.devMode);
    };

    const executeDarkModeToggle = () => {
        layoutConfig.darkTheme = !layoutConfig.darkTheme;

        localStorage.setItem('darkMode', layoutConfig.darkTheme);

        document.documentElement.classList.toggle('app-dark');
    };

    const toggleMenu = () => {
        if (isDesktop()) {
            if (layoutConfig.menuMode === 'static') {
                layoutState.staticMenuInactive = !layoutState.staticMenuInactive;
            }
            if (layoutConfig.menuMode === 'overlay') {
                layoutState.overlayMenuActive = !layoutState.overlayMenuActive;
            }
        } else {
            layoutState.mobileMenuActive = !layoutState.mobileMenuActive;
        }
    };

    const toggleConfigSidebar = () => {
        layoutState.configSidebarVisible = !layoutState.configSidebarVisible;
    };

    const toggleSidebarCollapse = () => {
        layoutConfig.sidebarCollapsed = !layoutConfig.sidebarCollapsed;
        localStorage.setItem('sidebarCollapsed', layoutConfig.sidebarCollapsed);
    };

    const hideMobileMenu = () => {
        layoutState.mobileMenuActive = false;
    };

    const isDevMode = computed(() => layoutConfig.devMode);

    const changeMenuMode = (event) => {
        layoutConfig.menuMode = event.value;
        layoutState.staticMenuInactive = false;
        layoutState.mobileMenuActive = false;
        layoutState.sidebarExpanded = false;
        layoutState.menuHoverActive = false;
        layoutState.anchored = false;
    };

    const isDarkTheme = computed(() => layoutConfig.darkTheme);
    const isDesktop = () => window.innerWidth > 991;

    const hasOpenOverlay = computed(() => layoutState.overlayMenuActive);

    return {
        layoutConfig,
        layoutState,
        isDarkTheme,
        isDevMode,
        toggleDarkMode,
        toggleConfigSidebar,
        toggleSidebarCollapse,
        toggleMenu,
        hideMobileMenu,
        changeMenuMode,
        isDesktop,
        hasOpenOverlay,
        toggleDevMode
    };
}
